import * as React from "react"
import axios from "axios"
import { hydrate } from "react-dom"
import { Router } from "react-router-dom"

import { After, ensureReady } from "@jaredpalmer/after"
import { set, pageview, initialize } from "react-ga"
import { CookiesProvider, Cookies } from "react-cookie"
import * as Sentry from "@sentry/browser"
import { Location } from "history"

import routes from "./routes"
import history from "./dev-history"
import App from "./App"
import { load as axiosLoader } from "./axios-nprogress"
import smoothscroll from "smoothscroll-polyfill"
import "./styles/custom.scss"

smoothscroll.polyfill()

axiosLoader()

Sentry.init({
	dsn: process.env.RAZZLE_SENTRY_DSN || "",
})

initialize(process.env.RAZZLE_GOOGLE_ANALYTICS_TRACKING_ID!)

// trigger page view for first time we lunach GA
pageChange(history.location)

history.listen(pageChange)

function pageChange(location: Location) {
	set({ page: location.pathname })
	pageview(location.pathname)
}

function requestNeedAuthentication(url: string) {
	const urls = [
		"/getCaptcha",
		"/getHomePage",
		"/doSearch",
		"/getDownloads",
		"/getPost",
		"/getBlog",
		"/getLearn",
		"/getProvince",
		"/getCity",
		"/getShop",
		"/getProduct",
	]

	return urls.every((item) => !url.includes(item))
}

const cookies = new Cookies()
const token = cookies.get("authToken")
if (token) {
	axios.defaults.headers.common["Authorization"] = token
}

axios.defaults.baseURL = process.env.RAZZLE_API_BASE_URL!

axios.interceptors.response.use(
	(response) => response,
	(error) => {
		if (error.response.status === 401) {
			cookies.remove("authToken")
			history.push("/login")
		}
		return Promise.reject(error)
	}
)

axios.interceptors.request.use(
	(request) => {
		if (!request.url) return request
		if (!requestNeedAuthentication(request.url)) {
			delete request.headers.common["Authorization"]
		}
		return request
	},
	(error) => Promise.reject(error)
)

ensureReady(routes).then((data) => {
	hydrate(
		<CookiesProvider cookies={cookies}>
			<Router history={history}>
				<App>
					<After
						routes={routes}
						isPhoneSized={window.isPhoneSized}
						data={data}
					/>
				</App>
			</Router>
		</CookiesProvider>,
		document.getElementById("root")
	)
})

if (process.env.NODE_ENV === "production" && "serviceWorker" in navigator) {
	window.addEventListener("load", () => {
		navigator.serviceWorker
			.register("/service-worker.js")
			.then(console.log.bind(window))
			.catch(console.log.bind(window))
	})
}

if (module.hot) {
	module.hot.accept()
}
